import React, { useState, useEffect } from 'react'
import Hero from '../components/Hero'
import FeaturedSection from '../components/home/FeaturedSection'
import TrustStrip from '../components/TrustStrips'
import Categories from '../components/Categories'
import NewArrivalsSection from '../components/home/NewArrivalsSection'
import BestsellersSection from '../components/home/BestsellersSection'
import DealSection from '../components/home/DealSection'
import { getHomepageConfig } from '../services/homepage.service'

const Home = () => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    getHomepageConfig().then(setConfig);
  }, []);

  return (
    <div className="bg-fecos-bg min-h-screen selection:bg-fecos-accent selection:text-white">
      <Hero />
      <TrustStrip />

      {/* Dynamic Sections */}
      <FeaturedSection />

      <NewArrivalsSection />

      <BestsellersSection />

      {config && <DealSection dealConfig={config.dealOfDay} />}

      <Categories />
    </div>
  )
}

export default Home